import { MENU_TOGGLE, GET_MENU, GET_ROUTELIST, LOGIN_OUT, GET_WZJK_LIST, GET_VEHICLE_INFO, GET_SELECCT_KEY, GET_CHANGE_LIST } from './actionType'

const defaultStore = {
  menuToggle: false,
  menukey: '',
  routePointList: [
    // { name: '南京大学', lnglat: [118.95900238964842, 32.1171223468328] },
    // { name: '浙江大学', lnglat: [118.91746033642576, 32.10112795252324] },
    // { name: '复旦大学', lnglat: [118.8920544526367, 32.045562031210935] },
    // { name: '交通大学', lnglat: [118.85806549999998, 32.00160906017225] }
  ],
  wzjkList: [],
  vehicleInfo: [],
  selectKey: '',
  changeList: []
}

export default (state = defaultStore, action) => {
  const { type, payload } = action
  switch (type) {
    case MENU_TOGGLE:
      return { ...state, menuToggle: !state.menuToggle }
    case GET_MENU:
      return { ...state, menukey: payload.content }
    case GET_ROUTELIST:
      return { ...state, routePointList: payload.list }
    case GET_WZJK_LIST:
      return { ...state, wzjkList: [...payload] }
    case GET_VEHICLE_INFO:
      return { ...state, vehicleInfo: [...payload] }
    case GET_SELECCT_KEY:
      return { ...state, selectKey: payload }
    case GET_CHANGE_LIST:
      return { ...state, changeList: payload }
    case LOGIN_OUT:
      return defaultStore
    default:
      return state
  }
}
